import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-final-form';

const NewToggleButton = ({ id, name, labelText, storedValue }) => {
  const form = useForm();
  const [isActive, setIsActive] = useState(storedValue);

  useEffect(() => {
    setIsActive(storedValue);
  }, [storedValue]);

  const toggleActiveState = () => {
    setIsActive(!isActive);
    form.change(name, !isActive);
  };

  return (
    <div
      id={id}
      role="button"
      tabIndex={0}
      onClick={toggleActiveState}
      onKeyPress={toggleActiveState}
      className="toggle-btn-container"
    >
      {labelText && <span className="toggle-btn__label">{labelText}</span>}
      <div className={`toggle-btn ${isActive ? 'toggle-btn--active' : ''}`}>
        <div
          className={`toggle-btn__circle ${
            isActive ? 'toggle-btn__circle--active' : ''
          }`}
        />
      </div>
    </div>
  );
};

NewToggleButton.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  labelText: PropTypes.string,
  storedValue: PropTypes.bool
};

export default NewToggleButton;
